import React from 'react';
import PropTypes from 'prop-types';

import { useDebounce } from '@/exceed';

import useAiGenerateLearningObjectivesChat from '../hooks/useAiGenerateLearningObjectivesChat';
import useSocketsSubscription from '../../exceed/hooks/useSocketsSubscription';

import LearningObjectivesList from './learningObjectivesList';

const AiGenerateLearningObjectivesChat = ({
  channelName = '',
  handleActionItemClick = () => {},
  handleKebabMenuItemClick = () => {},
  isLearningObjectivesDisplayed = false,
  isReadOnly = false,
  isSourceMaterialProcessed = false,
  objectiveableId = null,
  orderedLearningObjectives = {},
  refetchLearningObjectives = () => {},
  renderCustomPlaceholder = () => {},
  renderListItem = () => {},
  reorderLearningObjectives = () => {},
  shouldShowEmptyState = false,
  shouldShowNestedRows = false,
  shouldShowLoadingState = true,
}) => {
  const debouncedRefetchLearningObjectives = useDebounce(refetchLearningObjectives);
  const { connect, disconnect, isConnected } = useSocketsSubscription({
    channelName,
    events: {
      complete: (payload) => {
        if (payload.event === 'success') refetchLearningObjectives();
      },
      create: (payload) => {
        if (payload.event === 'create') debouncedRefetchLearningObjectives();
      },
    },
    options: {
      shouldAutoConnect: false,
    },
  });

  const onCloseChatExtraActions = () => {
    debouncedRefetchLearningObjectives();
  };

  const { intellumTutorStatus, hasIntellumTutorAPILoaded, openChat } =
    useAiGenerateLearningObjectivesChat({
      connect,
      disconnect,
      objectiveableId,
      onCloseChatExtraActions, // on close chat, refetch learning objectives 
    });

  const isGenerating = intellumTutorStatus === 'loading' || intellumTutorStatus === 'open' || isConnected;

  return (
    <LearningObjectivesList
      handleActionItemClick={handleActionItemClick}
      handleAiGenerateClick={openChat}
      handleKebabMenuItemClick={handleKebabMenuItemClick}
      isAiGenerateButtonDisabled={!isSourceMaterialProcessed}
      isGenerating={isGenerating}
      isReadOnly={isReadOnly}
      isLearningObjectivesDisplayed={isLearningObjectivesDisplayed}
      renderCustomPlaceholder={renderCustomPlaceholder}
      renderListItem={renderListItem}
      orderedLearningObjectives={orderedLearningObjectives}
      reorderLearningObjectives={reorderLearningObjectives}
      shouldShowAiGenerateButton={hasIntellumTutorAPILoaded}
      shouldShowEmptyState={shouldShowEmptyState}
      shouldShowNestedRows={shouldShowNestedRows}
      shouldShowLoadingState={shouldShowLoadingState}
    />
  );
};

AiGenerateLearningObjectivesChat.propTypes = {
  channelName: PropTypes.string,
  handleActionItemClick: PropTypes.func,
  handleKebabMenuItemClick: PropTypes.func,
  isLearningObjectivesDisplayed: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isSourceMaterialProcessed: PropTypes.bool,
  objectiveableId: PropTypes.number,
  orderedLearningObjectives: PropTypes.shape({}),
  refetchLearningObjectives: PropTypes.func,
  renderCustomPlaceholder: PropTypes.func,
  renderListItem: PropTypes.func,
  reorderLearningObjectives: PropTypes.func,
  shouldShowEmptyState: PropTypes.bool,
  shouldShowNestedRows: PropTypes.bool,
  shouldShowLoadingState: PropTypes.bool,
};

export default AiGenerateLearningObjectivesChat;
